import { LearningType } from "./LearningType";
import styles from "./LearningTypeCell.module.css";

interface LearningTypeCellProps {
  type: LearningType;
  title: string;
  description: string;
  image: string;
  style: "normal" | "list";
  onClick: () => void;
}

export default function LearningTypeCell(props: LearningTypeCellProps) {
  const containerClass =
    props.style === "normal" ? styles.container : styles.containerStyleList;

  const iconClass =
    props.style === "normal" ? styles.typeIcon : styles.typeIconcStyleList;

  const titleClass =
    props.style === "normal" ? styles.titleText : styles.titleTextStyleList;

  return (
    <>
      <div className={containerClass} onClick={() => props.onClick()}>
        <img className={iconClass} src={props.image} />
        <p className={titleClass}>{props.title}</p>
      </div>
    </>
  );
}
